define(['app', 'jquery', '../../utils/globalEvents', '../../utils/likePostRequest'], function (app, $, events, likePostRequest) {
  var activeClass = 'is-active'
  var disabledClass = 'is-disabled'

  return app.Marionette.ItemView.extend({
    template: false,

    options: {
      type: 'like',
      showIdeaVotesText: false,
      labels: {}
    },

    ui: {
      likeText: '.js-like-total'
    },

    events: {
      click: 'clickedButton'
    },

    initialize: function () {
      this.options.currentLikes = parseInt(this.options.currentLikes, 10) || 0
    },

    // Like functionality after user clicks the like button and is allowed to like this
    clickedButton: function (e) {
      // Get the data-object and set as variable in this function
      var likesData = this.options

      e.preventDefault()

      if (likesData.isGuest) {
        app.events.commands.execute('modal:login:show')
        return true
      }

      if (this.xhr || !likesData.likeEnabled) {
        return true
      }

      // Fake update the like number with 1, so the user gets immediate feedback
      if (!likesData.userLikes) {
        likesData.currentLikes += 1
      } else {
        likesData.currentLikes -= 1
      }

      this.ui.likeText.html(this.options.currentLikes)

      likesData.userLikes = !likesData.userLikes

      this.$el.toggleClass(activeClass, likesData.userLikes)

      events.commands.execute('post:like:' + likesData.postid, {
        currentUserHasLiked: likesData.userLikes,
        numberOfLikes: likesData.currentLikes
      })
      this.$el.addClass(disabledClass)

      var topicId = this.options.isFirstPost ? this.options.tid : null

      this.xhr = likePostRequest(topicId, likesData.postid, likesData.userLikes, () => {
        this.xhr = null
        this.$el.removeClass(disabledClass)
      })

      if (likesData.showIdeaVotesText) {
        this.updateVotesText(likesData.currentLikes, likesData.userLikes)
      }
    },

    updateVotesText: function (totalLikes, selfLiked) {
      var text = ''

      switch (totalLikes) {
        case 0:
          break
        case 1:
          text = this.options.labels['votes.idea.single']
          break
        case 2:
          if (selfLiked) {
            text = this.options.labels['votes.idea.single.and.self'].replace(
              '{total}',
              1
            )
          } else {
            text = this.options.labels['votes.idea.multi'].replace(
              '{total}',
              2
            )
          }
          break
        default:
          if (selfLiked) {
            text = this.options.labels['votes.idea.multi.and.self'].replace(
              '{total}',
              totalLikes - 1
            )
          } else {
            text = this.options.labels['votes.idea.multi'].replace(
              '{total}',
              totalLikes
            )
          }
          break
      }

      this.$el.next().text(text)
    }
  })
})
